import React, { useEffect, useRef } from 'react';
import './AlertDialog.css';

function AlertDialog({
  isOpen,
  message,
  type = 'info', // 'success', 'error', 'info'
  onClose
}) {
  const savedScrollPosition = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (isOpen) {
      // Save current scroll position
      savedScrollPosition.current = {
        x: window.scrollX || window.pageXOffset,
        y: window.scrollY || window.pageYOffset
      };

      // Just prevent scrolling, don't change position
      document.body.style.overflow = 'hidden';
    } else {
      // Restore body scroll
      document.body.style.overflow = '';

      // Restore scroll position after a small delay to ensure DOM is ready
      requestAnimationFrame(() => {
        window.scrollTo(savedScrollPosition.current.x, savedScrollPosition.current.y);
      });
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Auto-close success messages after 3 seconds
  useEffect(() => {
    if (isOpen && type === 'success') {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, type, onClose]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      default:
        return 'ℹ';
    }
  };

  return (
    <>
      <div className="alert-overlay" onClick={onClose} />
      <div className={`alert-dialog alert-${type}`}>
        <div className="alert-icon">{getIcon()}</div>
        <div className="alert-content">
          <div className="alert-message">
            {message.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < message.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
          <button
            className="alert-close-btn"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </>
  );
}

export default AlertDialog;
